module.exports = __webpack_public_path__ + "static/media/python.5b524739.jpg";